export type ParentFacingGooglePersona = 'staff' | 'administrator' | 'parent';

export const resolveParentFacingGooglePersona = ({
  requestedPersona,
}: {
  requestedPersona: ParentFacingGooglePersona | '' | null | undefined;
}): ParentFacingGooglePersona => {
  if (requestedPersona) {
    return requestedPersona;
  }
  return 'parent';
};

export const resolveParentFacingGoogleOAuthPersona = ({
  mode,
  hasProvisioningIntent,
  requestedPersona,
}: {
  mode: 'signin' | 'signup';
  hasProvisioningIntent: boolean;
  requestedPersona: ParentFacingGooglePersona | '' | null | undefined;
}): ParentFacingGooglePersona | null => {
  if (mode !== 'signin' || !hasProvisioningIntent) {
    return null;
  }
  return resolveParentFacingGooglePersona({ requestedPersona });
};

export const shouldRequestParentFacingGooglePersonaSelection = ({
  mode,
  hasProvisioningIntent,
}: {
  mode: 'signin' | 'signup';
  hasProvisioningIntent: boolean;
}): boolean =>
  mode !== 'signup'
  && !hasProvisioningIntent;
